import it from './it.json';
import en from './en.json';

const messages = { it, en };

export default { messages, invariant: 'en' };



// WEBPACK FOOTER //
// ./src/app/@remax-it/locales/index.js